<template>
  <v-row dense>
    <v-col>
      <v-row dense>
        <v-col>
          <v-combobox
            label="Fabricante"
            v-model="manufacturer"
            outlined
            dense
            background-color="white"
            :items="manufacturers"
            item-text="name"
            @change="changeManufacturer"
            :hide-details="errors.manufacturer"
            :error-messages="errors.manufacturer"
            data-testid="manufacturer-input"
          />
        </v-col>
      </v-row>

      <v-row dense>
        <v-col>
          <v-combobox
            label="Tipo"
            v-model="prosthesisType"
            outlined
            dense
            background-color="white"
            :items="prosthesisTypes"
            item-text="name"
            @change="changeProsthesisType"
            :hide-details="errors.prosthesisType"
            :error-messages="errors.prosthesisType"
            data-testid="prothesis-type-input"
          />
        </v-col>
      </v-row>

      <v-row dense>
        <v-col>
          <v-combobox
            label="Modelo"
            v-model="model"
            outlined
            dense
            background-color="white"
            :items="models"
            item-text="name"
            :hide-details="errors.model"
            :error-messages="errors.model"
            data-testid="model-input"
          />
        </v-col>
      </v-row>

      <v-row dense>
        <v-col>
          <v-combobox
            label="Dioptria"
            v-model="diopter"
            outlined
            dense
            :menu-props="{ auto: true, maxHeight: 304 }"
            background-color="white"
            :items="diopters"
            :hide-details="errors.diopter"
            :error-messages="errors.diopter"
          />
        </v-col>
      </v-row>

      <v-row dense>
        <v-col>
          <v-textarea
            label="Observações"
            v-model="observation"
            v-uppercase
            hide-details
            outlined
            dense
            background-color="white"
          />
        </v-col>
      </v-row>

      <v-row dense>
        <v-col>
          <v-btn color="primary" block small @click="saveProsthesis" data-testid="submit-button"
            >Salvar prótese</v-btn
          >
        </v-col>

        <v-col cols="4">
          <v-btn color="secondary" block small @click="cancelProsthesis" data-testid="cancel-button"
            >Cancelar</v-btn
          >
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "ProsthesisForm",
  props: {
    surgeryIndicationId: {
        type: String,
        required: true
    },
    surgeryIndicationProsthesis: Object,
  },
  data() {
    return {
      errors: {},
      manufacturer: null,
      prosthesisType: null,
      model: null,
      diopter: "a calcular",
      observation: "",
    };
  },
  watch: {
    surgeryIndicationProsthesis() {
      this.loadSurgeryIndicationProsthesis();
    },
  },
  apollo: {
    prostheses: {
      query: require("@/graphql/prosthesis/prostheses.gql"),
    },
  },
  computed: {
    diopters() {
      let diopters = [];

      for (let index = -10; index <= 34; index += 0.5) {
        let dipoter = `${index.toFixed(2)}`;

        if (index >= 0) {
          dipoter = `+${index.toFixed(2)}`;
        }

        diopters.push(dipoter.replace(".", ","));
      }

      diopters.splice(diopters.length / 2, 0, "a calcular");

      return diopters;
    },
    manufacturers() {
      if (this.prostheses) {
        return this.lodash.orderBy(
          this.lodash.filter(
            this.lodash.uniqBy(
              this.prostheses.map((e) => e.manufacturer),
              "id"
            ),
            ["deletedAt", null]
          ),
          [
            (e) =>
              e.name
                .toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, ""),
          ],
          ["asc"]
        );
      }

      return [];
    },
    prosthesisTypes() {
      if (this.prostheses && this.manufacturer?.id) {
        let prostheses = this.lodash.filter(
          this.prostheses,
          function(e) {
            return e.manufacturer.id === this.manufacturer.id;
          }.bind(this)
        );

        return this.lodash.uniqBy(
          prostheses.map((e) => e.prosthesisType),
          "id"
        );
      }

      return [];
    },
    models() {
      let prostheses = this.prostheses;

      if (this.manufacturer?.id) {
        prostheses = this.lodash.filter(
          prostheses,
          function(e) {
            return e.manufacturer.id === this.manufacturer.id;
          }.bind(this)
        );
      }

      if (this.prosthesisType?.id) {
        prostheses = this.lodash.filter(
          prostheses,
          function(e) {
            return e.prosthesisType.id === this.prosthesisType.id;
          }.bind(this)
        );
      }

      return this.lodash.orderBy(
        this.lodash.filter(prostheses, ["deletedAt", null]),
        [
          (e) =>
            e.name
              .toLowerCase()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, ""),
        ],
        ["asc"]
      );
    },
  },
  methods: {
    changeManufacturer() {
      this.prosthesisType = null;
      this.changeProsthesisType();
    },
    changeProsthesisType() {
      this.model = null;
    },
    validate() {
      const errorMsg = "Esse campo deve ser preenchido.";
      this.errors = {};

      if (!this.manufacturer?.id) {
        this.errors.manufacturer = errorMsg;
      }

      if (!this.prosthesisType?.id) {
        this.errors.prosthesisType = errorMsg;
      }

      if (!this.model?.id) {
        this.errors.model = errorMsg;
      }

      // if (
      //   this.lodash.isEmpty(this.diopter.trim()) ||
      //   this.diopter === "Em branco"
      // ) {
      //   this.errors.diopter = errorMsg;
      // }

      if (Object.keys(this.errors).length === 0) {
        return true;
      }

      return false;
    },
    saveProsthesis() {
      if (!this.validate()) return;
      return this.apolloMutate({
        mutation: require("@/graphql/surgery_indication/save_prosthesis_surgery_indication.gql"),
        variables: {
          surgeryIndicationId: this.surgeryIndicationId,
          prosthesisId: this.lodash.get(this.model, "id", ""),
          surgeryIndicationProsthesisId: this.lodash.get(
            this.surgeryIndicationProsthesis,
            "id",
            ""
          ),
          diopter: this.diopter,
          observation: this.observation,
          chosen: this.lodash.get(
            this.surgeryIndicationProsthesis,
            "chosen",
            false
          ),
        },
      }).then(() => {
        this.cancelProsthesis();
        this.$store.dispatch("createNotification", {
          message: "Prótese criada com sucesso.",
          type: "success",
        });
      }).catch((err) => {
        console.log(err)
      });
    },
    loadSurgeryIndicationProsthesis() {
      if (this.surgeryIndicationProsthesis) {
        this.diopter = this.surgeryIndicationProsthesis.diopter;
        this.observation = this.surgeryIndicationProsthesis.observation;

        this.model = this.lodash.find(this.models, {
          id: this.surgeryIndicationProsthesis.prosthesis.id,
        });

        this.manufacturer = this.model.manufacturer;
        this.prosthesisType = this.model.prosthesisType;
      } else {
        this.cancelProsthesis();
      }
    },
    cancelProsthesis() {
      this.diopter = "Em branco";
      this.observation = "";
      this.model = "";
      this.manufacturer = "";
      this.prosthesisType = "";
    },
  },
};
</script>

<style lang="scss" scoped></style>
